import { deserialize, serialize, type SaveState } from "@pj/state";

const KEY = "pj.save.v1";

/** Load the local save (tolerant: bad/missing data → fresh save). */
export function loadSave(): SaveState {
  try {
    return deserialize(localStorage.getItem(KEY));
  } catch {
    return deserialize(null);
  }
}

export function persistSave(save: SaveState): void {
  try {
    localStorage.setItem(KEY, serialize(save));
  } catch {
    // localStorage may be unavailable (private mode) — progression stays in-memory.
  }
}

/** Wipe saved progress (EXP/Power, abilities, completed levels, bhaav attempt). */
export function clearSave(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
